import { Link, type LinkProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/**
 * "Need help? Contact us" mailto link used in the onboarding and paywall top
 * bars. Accepts `LinkProps` overrides for per-surface layout tweaks (e.g.
 * `ml="auto"` in the onboarding top bar).
 */
export const ContactHelpLink = (props: LinkProps) => {
  const { t } = useTranslation();

  return (
    <Link
      href="mailto:contact@fluenceur.com"
      fontFamily="body"
      fontSize="13px"
      color="#8b8579"
      _hover={{ textDecoration: 'none' }}
      {...props}
    >
      {t('onboarding.needHelp')}
    </Link>
  );
};
